import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["children", "className", "description", "error", "value"];
import React from "react";
import Input from "react-phone-input-2";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line react/display-name
export var PhoneInput = props => {
  var {
    children,
    description,
    error,
    value = "61"
  } = props,
      rest = _objectWithoutPropertiesLoose(props, _excluded);

  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("label", {
      htmlFor: rest.id,
      className: "p-1 block font-medium",
      children: children
    }), /*#__PURE__*/_jsxs("div", {
      className: "mt-1 relative",
      children: [/*#__PURE__*/_jsx(Input, _extends({
        inputProps: {
          required: true,
          autoComplete: "tel"
        },
        preferredCountries: ["au"],
        value: value
      }, rest, {
        inputStyle: {
          fontSize: "100%"
        },
        containerStyle: {
          fontSize: "100%"
        },
        inputClass: "!bg-white !w-full !h-full !border-grey-300/20 !pr-3 !py-1.5",
        buttonClass: "!bg-white !border-grey-300/20",
        containerClass: "!w-full !text-inherit"
      })), description && /*#__PURE__*/_jsx("small", {
        className: "p-1 opacity-50",
        children: description
      }), error && /*#__PURE__*/_jsx("small", {
        className: "text-red-400 p-1",
        children: error
      })]
    })]
  });
};
//# sourceMappingURL=phoneinput.js.map